import { Clock } from "lucide-react";

const WAIT_CONFIG = {
  no_wait: { color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200", label: "Walk right up", dot: "bg-emerald-500" },
  under_5: { color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200", label: "Short wait", dot: "bg-emerald-500" },
  "5_to_15": { color: "text-amber-600", bg: "bg-amber-50", border: "border-amber-200", label: "Moderate wait", dot: "bg-amber-500" },
  "15_to_30": { color: "text-orange-600", bg: "bg-orange-50", border: "border-orange-200", label: "Longer wait", dot: "bg-orange-500" },
  over_30: { color: "text-red-600", bg: "bg-red-50", border: "border-red-200", label: "Long wait", dot: "bg-red-500" },
};

function getFreshness(reportedAt) {
  if (!reportedAt) return "none";
  const age = (Date.now() - new Date(reportedAt).getTime()) / 60000;
  if (age <= 30) return "fresh";
  if (age <= 60) return "stale";
  return "expired";
}

export default function WaitTimeDisplay({ waitMinutes, waitCategory, reportedAt, reporterCount, onTap, compact = false }) {
  if (waitMinutes == null && !waitCategory) return null;
  if (!reportedAt) return null;

  const freshness = getFreshness(reportedAt);
  if (freshness === "expired" || freshness === "none") return null;

  const config = WAIT_CONFIG[waitCategory] || WAIT_CONFIG.under_5;
  const ageMins = Math.round((Date.now() - new Date(reportedAt).getTime()) / 60000);

  if (freshness === "stale") {
    return (
      <button
        onClick={(e) => { e.stopPropagation(); onTap?.(); }}
        className="flex items-center gap-1.5 text-slate-400 text-[10px]"
        data-testid="wait-time-stale"
      >
        <Clock className="w-3 h-3" />
        <span>Wait reported {ageMins}m ago</span>
      </button>
    );
  }

  if (compact) {
    return (
      <button
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); onTap?.(); }}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full ${config.bg} border ${config.border} ${config.color} text-[10px] font-semibold relative z-10`}
        data-testid="wait-time-fresh"
      >
        <div className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
        {config.label}
        {waitMinutes > 0 && <span className="text-[9px] opacity-70">~{waitMinutes}m</span>}
      </button>
    );
  }

  return (
    <button
      onClick={(e) => { e.stopPropagation(); e.preventDefault(); onTap?.(); }}
      className={`w-full flex items-center gap-2 px-3 py-2 rounded-xl ${config.bg} border ${config.border} transition hover:opacity-80 relative z-10`}
      data-testid="wait-time-fresh"
    >
      <div className={`w-2.5 h-2.5 rounded-full ${config.dot} shrink-0`} />
      <div className="flex-1 text-left">
        <span className={`text-xs font-bold ${config.color}`}>{config.label}</span>
        {waitMinutes > 0 && <span className={`text-[10px] ${config.color} opacity-70 ml-1`}>~{waitMinutes} min</span>}
      </div>
      {reporterCount > 1 && (
        <span className="text-[9px] text-slate-400">{reporterCount} reports</span>
      )}
    </button>
  );
}
